var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 18.2502L14.2689 14.2691M14.2689 14.2691C14.9499 13.5881 15.4901 12.7797 15.8586 11.8899C16.2272 11.0002 16.4169 10.0466 16.4169 9.08352C16.4169 8.12047 16.2272 7.16685 15.8586 6.2771C15.4901 5.38736 14.9499 4.57892 14.2689 3.89794C13.5879 3.21696 12.7795 2.67678 11.8897 2.30823C11 1.93969 10.0464 1.75 9.08333 1.75C8.12028 1.75 7.16666 1.93969 6.27691 2.30823C5.38717 2.67678 4.57873 3.21696 3.89775 3.89794C2.52245 5.27324 1.74981 7.13855 1.74981 9.08352C1.74981 11.0285 2.52245 12.8938 3.89775 14.2691C5.27305 15.6444 7.13836 16.417 9.08333 16.417C11.0283 16.417 12.8936 15.6444 14.2689 14.2691Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlack);
export default __webpack_public_path__ + "static/media/search-icon-black.e098a4677836f1de499d1bc109bd7874.svg";
export { ForwardRef as ReactComponent };